import { AbstractListLoader } from './abstract-list-loader';
import { ColumnSortModel, TableSortModel } from '../../tablesort/tableSortModel';
import { Observable } from 'rxjs';
import { LoadingState } from './loading-state';

export class ListLoaderObservable<T> extends AbstractListLoader<T> {
  allItems: Array<T>;

  private sortModel: ColumnSortModel<T>;

  constructor(pageSize, currentPage = 1, observable: Observable<Array<T>>) {
    super(pageSize);
    this.stateSubject.next(LoadingState.INITIAL_LOADING);
    this.subscriptions.push(
      observable.subscribe({
        next: (array) => {
          this.allItems = array;
          this.totalItemsVisible = array.length;
          this.sortAllItems();
          this.internalChangePage(currentPage);
        },
        error: (err) => this.filterAccessDenied(err)
      })
    );
  }

  changePage(page: number) {
    if (this.currentPage === page) {
      return;
    }
    this.internalChangePage(page);
  }

  protected internalChangePage(page: number) {
    if (!this.allItems) {
      return;
    }
    this.currentPage = page;
    this.stateSubject.next(LoadingState.PAGE_LOADING);
    const start = this.pagerData.startIndex;
    const end = this.pagerData.endIndex;
    const items = this.allItems.slice(start, end);
    this.itemsSubject.next(items);
    this.stateSubject.next(LoadingState.ALL_DATA_LOADED);
  }

  applySortModel(tableSortModel: TableSortModel<T>) {
    this.tableSortModel = tableSortModel;
    const sub = this.tableSortModel.sortedColumns$.subscribe((sortModel) => {
      this.sortModel = sortModel;
      this.sortAllItems();
      this.internalChangePage(this.currentPage);
    });
    this.subscriptions.push(sub);
  }

  sortAllItems() {
    if (!this.sortModel) {
      return;
    }
    this.allItems = this.sortModel.sort(this.allItems);
  }
}
